import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import 'font-awesome/css/font-awesome.min.css';

class Footer extends Component {
  render() {
    const authLinks =
      this.props.auth.user.position !== 'Klijent' ? (
        <div className="container"> 
        <footer className="py-3 my-4">
         <ul className='nav justify-content-center border-bottom pb-3 mb-3'>
            <li className='nav-item'>
                <a className='nav-link px-2 text-muted' target='_blank' href="https://www.linkedin.com/company/galeb/mycompany/"><i className="fa fa-linkedin"></i></a>
              </li>
              <li className='nav-item'>
                <a className='nav-link px-2 text-muted' target='_blank' href="https://www.facebook.com/galebgroup/?locale=sr_RS"><i className="fa fa-facebook"></i></a>
              </li>
              <li className='nav-item'>
                <a className='nav-link px-2 text-muted' target='_blank' href="https://www.instagram.com/galeb_group/"><i className="fa fa-instagram"></i></a>
              </li>
            </ul>
        
        <p className="text-center text-muted">
            &copy; {new Date().getFullYear()}{' '}
              Galeb Electronics
        </p>
      </footer>
      </div>
      
      ) : (
        <footer className="footer">
          <Container fluid>
            <nav className="pull-left">
              <ul>
              <li>
                  <a target='_blank' href="https://www.linkedin.com/company/galeb/mycompany/"><i className="fa fa-linkedin"></i></a>
                </li>
                <li>
                  <a target='_blank' href="https://www.facebook.com/galebgroup/?locale=sr_RS"><i className="fa fa-facebook"></i></a>
                </li>
                <li>
                  <a target='_blank' href="https://www.instagram.com/galeb_group/"><i className="fa fa-facebook"></i></a>
                </li>
              </ul>
            </nav>
            <p className="copyright pull-right">
              &copy; {new Date().getFullYear()}{' '}
                Galeb Electronics
            </p>
          </Container>
        </footer>
      );
    return authLinks;
  }
}
const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(Footer);
